import { invalid } from 'moment';
import { FirebaseOptions } from 'firebase/app';

export const AppConfig = {
  apiHost: `${window.ENV.API_HOST}/`,
  logLevel: window.ENV.LOG_LEVEL,
  googleAPIKey: window.ENV.GOOGLE_API_KEY,
  healthlineUrl: window.ENV.HEALTHLINE_URL,
  contactUsUrl: window.ENV.CONTACT_US_URL,
  privacyUrl: window.ENV.PRIVACY_URL,
  helpUrl: window.ENV.HELP_URL,
  gaTrackingId: window.ENV.GA_TRACKING_ID,
  feedbackUrl: window.ENV.FEEDBACK_URL,
  baseHubUrl: window.ENV.BASE_HUB_URL,
  baseEconUrl: window.ENV.BASE_ECON_URL,
  baseGuestServeUrl: window.ENV.BASE_GUEST_URL,
  baseSelfServeUrl: window.ENV.BASE_SELF_SERVE_URL,
  baseScheduleUrl: window.ENV.BASE_SCHEDULE_URL,
  baseTeledermUrl: window.ENV.BASE_TELEDERM_URL,
  baseEvisitUrl: window.ENV.BASE_EVISIT_URL,
  baseSofLaunchUrl: window.ENV.BASE_SMARTONFHIR_URL,
  inactiveEconsultServiceUrl: window.ENV.INACTIVE_ECONSULT_SERVICE_URL,
  // FCM Configuration
  get fcmConfig(): {
    firebase: FirebaseOptions;
    vapidKey: string;
  } | null {
    const {
      FIREBASE_API_KEY,
      FIREBASE_DATABASE_URL,
      FIREBASE_PROJECT_ID,
      FIREBASE_MESSAGING_SENDER_ID,
      FIREBASE_APP_ID,
      FCM_VAPID_KEY
    } = window.ENV;
    // Return null if any required Firebase config is missing
    if (
      !FIREBASE_API_KEY ||
      !FIREBASE_DATABASE_URL ||
      !FIREBASE_PROJECT_ID ||
      !FIREBASE_MESSAGING_SENDER_ID ||
      !FIREBASE_APP_ID ||
      !FCM_VAPID_KEY
    ) {
      return null;
    }

    return {
      firebase: {
        apiKey: FIREBASE_API_KEY,
        databaseURL: FIREBASE_DATABASE_URL,
        projectId: FIREBASE_PROJECT_ID,
        messagingSenderId: FIREBASE_MESSAGING_SENDER_ID,
        appId: FIREBASE_APP_ID
      },
      vapidKey: FCM_VAPID_KEY
    };
  },

  get isFCMEnabled(): boolean {
    return this.fcmConfig !== null;
  }
};
